import { addScriptDefault } from 'meta-pixel'

export default addScriptDefault()
